import {regNavn} from "felles/tjenester/tredjepartsTjenestenavn";
import {IAttributes, IController, IModule, IRootScopeService} from "angular";
import {Debugger} from "debug";
import {Tidssonevalg} from "../../../felles/tjenester/i18n/Tidssonevalg";
import {InnlastingsindikatorKontroller} from "../../moduler/basis/direktiver/innlastingsindikator";
import _ from "lodash";

const debug: Debugger = require('debug')('TidssonevelgerKontroller');
const css = require('./tidssonevelger.scss');

export class TidssonevelgerKontroller implements IController {

    static tidssonevalgtEvent = "tidssonevalgtEvent";

    static registrerKomponent(angular: IModule) {
        angular.component('wkTidssonevelger', {
            bindings: {tidssone: '=?', kunVisning: '<?'},
            controller: TidssonevelgerKontroller.forInjisering(),
            template: require('./tidssonevelger.html')
        });
    }

    static forInjisering() {
        return [regNavn.ng.$rootScope, regNavn.ng.$attrs, Tidssonevalg.regNavn, TidssonevelgerKontroller];
    }

    constructor(private $rootScope: IRootScopeService, private $attrs: IAttributes, private tidssonevalg: Tidssonevalg) {
    }

    tidssone: string; //settes via bindings/$onChanges
    kunVisning: boolean; //settes via bindings/$onChanges

    visByttSone = false;
    tilgjengeligesoner: string[];

    oppdatertSone: string;
    lagrer = false;

    aktivTidssoneFormatert() {
        return Tidssonevalg.tidssoneFormatert(this.aktivTidssone())
    }

    aktivTidssone() {
        return !_.isNil(this.tidssone) ? this.tidssone : this.tidssonevalg.aktivTidssone();
    }

    visTidssonevelger() {
        this.lastTidssoner();
        this.visByttSone = true;
    }

    lagreValg() {
        if (this.kunVisning == true) return;

        this.tidssone = this.oppdatertSone
        this.visByttSone = false;

        this.tidssonevalg.angiTidssone(this.oppdatertSone);
        this.$rootScope.$emit(TidssonevelgerKontroller.tidssonevalgtEvent, this.oppdatertSone);
    }

    avbrytByttSone() {
        this.visByttSone = false;
        this.oppdatertSone = null;
    }

    // Callback

    oppdatertidssone(tidssone) {
        this.oppdatertSone = tidssone;
    }

    //hjelpmetoder

    private lastTidssoner() {
        if (!_.isNil(this.tilgjengeligesoner)) return;

        this.$rootScope.$emit(InnlastingsindikatorKontroller.vis_innlasting);
        return this.tidssonevalg.hentTilgjengeligeTidssoner().then((soner) => {
            this.tilgjengeligesoner = soner;
        }).finally(() => this.$rootScope.$emit(InnlastingsindikatorKontroller.innlasting_ferdig));
    }
}
